// api
import { az_optimize_content } from "@/pptjs/api/api_azure_openai.js";

// Pub
import { gptPubIds } from "@/service/wd_pubsub_config.js";
import { publish } from "@/service/wd_pubsub.js";
import store from "@store";

// i18n
import { i18n } from "@i18n";

// utils
import {
  getCurSlidePageNumber,
  getSlideTextWithName,
  updateSlideTextWithName,
} from "../util/gpt_addin_utils.js";

// VSTO Host Object
import { default as hostObject_slides } from "../vsto/vsto_slides.js";
import { default as hostObject_shapes } from "../vsto/vsto_shapes.js";
const vstoMode = store.get("app/vstoMode");
let curPageNumber = 0;

// 扩写内容
export async function process_expand_content(input) {
  publish(
    gptPubIds.pubId_Local_Gpt_ProcessingText,
    i18n.t("ppt_addin.process.text_ppt_generating_expand_content")
  );

  // 源文本
  let pptTopic = store.get("gpt/pptTopic");
  let contentText = pptTopic.length > 0 ? pptTopic + "\n" : "";
  let slideContent = "";
  curPageNumber = 0;
  if (vstoMode) {
    slideContent = await hostObject_shapes.vsto_getSlideTextWithName(
      "Content Placeholder"
    );
    if (typeof slideContent == "undefined" || slideContent.length == 0) {
      slideContent = await hostObject_shapes.vsto_getSlideTextWithName(
        "Text Placeholder"
      );
    }
    curPageNumber = await hostObject_slides.vsto_getCurPageNumber();
  } else {
    slideContent = await getSlideTextWithName("Content Placeholder");
    if (typeof slideContent == "undefined" || slideContent.length == 0) {
      slideContent = await getSlideTextWithName("Text Placeholder");
    }
    curPageNumber = await getCurSlidePageNumber();
  }
  contentText += slideContent;

  // 本地添加一条消息
  let userLogText = "";
  if (input.taskType) {
    userLogText += i18n.t("ppt_addin.message.text_userlog_format_current_page");
    userLogText = userLogText.replace(/\{0\}/g, curPageNumber + "");
    userLogText += input.taskType.title;
    if (input.taskOptions) {
      userLogText += ", ";
      userLogText += input.taskOptions.title;
    }
    userLogText += "<br />";
  }
  // 先去掉原内容，避免气泡过长
  // if (contentText.length > 0) {
  //   userLogText += i18n.t(
  //     "ppt_addin.message.text_userlog_format_optimized_content"
  //   );
  //   userLogText += contentText;
  //   userLogText += "<br />";
  // }
  if (input.text.length > 0) {
    if (input.taskType) {
      userLogText += i18n.t(
        "ppt_addin.message.text_userlog_format_your_description"
      );
    }
    userLogText += input.text;
  }
  publish(gptPubIds.pubId_Local_Addin_UserLog, userLogText);

  // 调用接口生成新内容
  var params = {
    taskType: input.taskType ? input.taskType.id : "",
    sourceText: contentText,
    inputText: input.text, //
  };
  await az_optimize_content(params).then(
    (response) => {
      handleGptExpandContentResponse(params, response);
    },
    (error) => {
      handleGptError(error);
    }
  );
}

async function handleGptExpandContentResponse(requestParams, response) {
  if (response.data.Code === 0) {
    publish(
      gptPubIds.pubId_Local_Gpt_ProcessingText,
      i18n.t("ppt_addin.process.text_ppt_generation_update_slide")
    );

    let gptMessage = response.data.Result.Content;
    // 把返回内容显示出来
    let systemLog = gptMessage.replace(/\n\n/g, "<br />");
    systemLog = systemLog.replace(/\n/g, "<br />");
    publish(gptPubIds.pubId_Local_Addin_SystemLog, systemLog);

    let contentUpdated = gptMessage.replace(/\n\n/g, "\r");
    contentUpdated = contentUpdated.replace(/\n/g, "\r");
    // 更改原有content shape的文本
    if (vstoMode) {
      await hostObject_shapes.vsto_updateSlideTextWithName(
        "Text Placeholder",
        contentUpdated
      );
    } else {
      await updateSlideTextWithName("Text Placeholder", contentUpdated);
    }

    // 发送log
    let increaseNumber =
      contentUpdated.length - requestParams.sourceText.length;
    let logText = i18n.t(
      "ppt_addin.process.text_ppt_generating_expand_content_success"
    );
    logText = logText.replace(/\{0\}/g, curPageNumber + "");
    logText = logText.replace(/\{1\}/g, increaseNumber + "");
    publish(gptPubIds.pubId_Local_Addin_SystemLog, logText);

    // end
    publish(gptPubIds.pubId_Local_Gpt_Processing_Success, "");
  }
}

async function handleGptError(error) {
  if (error) {
    publish(
      gptPubIds.pubId_Local_Addin_SystemLog,
      i18n.t("ppt_addin.process.text_ppt_generating_content_failed")
    );
    publish(gptPubIds.pubId_Local_Gpt_Processing_Fail, "");
  }
}

// 提炼内容
export async function process_extract_content(input) {
  publish(
    gptPubIds.pubId_Local_Gpt_ProcessingText,
    i18n.t("ppt_addin.process.text_ppt_generating_extract_content")
  );

  // 源文本
  let pptTopic = store.get("gpt/pptTopic");
  let contentText = pptTopic.length > 0 ? pptTopic + "\n" : "";
  let slideContent = "";
  curPageNumber = 0;
  if (vstoMode) {
    slideContent = await hostObject_shapes.vsto_getSlideTextWithName(
      "Content Placeholder"
    );
    if (typeof slideContent == "undefined" || slideContent.length == 0) {
      slideContent = await hostObject_shapes.vsto_getSlideTextWithName(
        "Text Placeholder"
      );
    }
    curPageNumber = await hostObject_slides.vsto_getCurPageNumber();
  } else {
    slideContent = await getSlideTextWithName("Content Placeholder");
    if (typeof slideContent == "undefined" || slideContent.length == 0) {
      slideContent = await getSlideTextWithName("Text Placeholder");
    }
    curPageNumber = await getCurSlidePageNumber();
  }
  contentText += slideContent;

  // 本地添加一条消息
  let userLogText = "";
  if (input.taskType) {
    userLogText += i18n.t("ppt_addin.message.text_userlog_format_current_page");
    userLogText = userLogText.replace(/\{0\}/g, curPageNumber + "");
    userLogText += input.taskType.title;
    if (input.taskOptions) {
      userLogText += ", ";
      userLogText += input.taskOptions.title;
    }
    userLogText += "<br />";
  }
  // 先去掉原内容，避免气泡过长
  // if (contentText.length > 0) {
  //   userLogText += i18n.t(
  //     "ppt_addin.message.text_userlog_format_optimized_content"
  //   );
  //   userLogText += contentText;
  //   userLogText += "<br />";
  // }
  if (input.text.length > 0) {
    if (input.taskType) {
      userLogText += i18n.t(
        "ppt_addin.message.text_userlog_format_your_description"
      );
    }
    userLogText += input.text;
  }
  publish(gptPubIds.pubId_Local_Addin_UserLog, userLogText);

  // 调用接口，提炼文本
  var params = {
    taskType: input.taskType ? input.taskType.id : "",
    sourceText: contentText,
    inputText: input.text, //
  };
  await az_optimize_content(params).then(
    (response) => {
      handleGptExtractContentResponse(params, response);
    },
    (error) => {
      handleGptError(error);
    }
  );
}

async function handleGptExtractContentResponse(requestParams, response) {
  if (response.data.Code === 0) {
    publish(
      gptPubIds.pubId_Local_Gpt_ProcessingText,
      i18n.t("ppt_addin.process.text_ppt_generation_update_slide")
    );

    let gptMessage = response.data.Result.Content;
    // 把返回内容显示出来
    let systemLog = gptMessage.replace(/\n\n/g, "<br />");
    systemLog = systemLog.replace(/\n/g, "<br />");
    publish(gptPubIds.pubId_Local_Addin_SystemLog, systemLog);

    let contentUpdated = gptMessage.replace(/\n\n/g, "\r");
    contentUpdated = contentUpdated.replace(/\n/g, "\r");
    // 更改原有content shape的文本
    // 更改原有content shape的文本
    if (vstoMode) {
      await hostObject_shapes.vsto_updateSlideTextWithName(
        "Text Placeholder",
        contentUpdated
      );
    } else {
      await updateSlideTextWithName("Text Placeholder", contentUpdated);
    }

    // 发送log
    let count = requestParams.sourceText.length - contentUpdated.length;
    let logText = i18n.t(
      "ppt_addin.process.text_ppt_generating_extract_content_success"
    );
    logText = logText.replace(/\{0\}/g, curPageNumber + "");
    logText = logText.replace(/\{1\}/g, count + "");
    publish(gptPubIds.pubId_Local_Addin_SystemLog, logText);

    // end
    publish(gptPubIds.pubId_Local_Gpt_Processing_Success, "");
  }
}
